<template>
  <div class="custom-tooltip inline-block absolute left-16 -top-4 h-16 w-52 bg-black text-white p-2 pr-7 pl-2 text-sm rounded-md transition-opacity shadow-sm">
    <button type="button" class="absolute" @click="$emit('tooltipVisibility', false)">
      <font-awesome-icon
          :icon="['far', 'xmark']"
          class="text-xl mr-2"
      ></font-awesome-icon></button>
    <p class="leading-2 text-white mt-0">  {{ message }}</p>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
library.add(faXmark);
export default {
  name: "CustomTooltip",
  emits: ['tooltipVisibility'],
  props: {
    message: {
      type: String,
      default: ""
    },
  },
};
</script>
<style scoped lang="scss">
.leading-2 {
  white-space: pre-wrap; /* Or white-space: pre; */
}
.custom-tooltip{
  top: -60px;
}
.custom-tooltip::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
}
.custom-tooltip button{
  right: -4px;
  top: 0px;
}
.custom-tooltip button svg{
  font-size: 14px;
}
</style>
